<template>
  <div class='new-item'>
    <app-title class="market-title" :title="lang[0]"></app-title>
    <div class="img-area">
      <div v-for="val in 5" class="item-img-wrapper">
        <label
          v-if="item['img'+val]"
          :for="`img${val}`"
          class="item-img"
          :style="`background-image: url(${item['img'+val]})`">
        </label>
        <label
          v-else
          :for="`img${val}`"
          :style="`background-image: url(${defcamera})`"
          class="item-img">
        </label>
        <input
          :id="`img${val}`"
          type="file"
          name="file"
          accept="image/*"
          @change="selectedFile"
          style="display: none;"
        >
      </div>
    </div>
    <p class="validate">{{ers.img1}}</p>
    <div class="form-wrapper">
      <n-input
        v-model="item.name"
        type="text"
        :placeholder="lang[1]"
        @chargeRifleInput="nullCheckVal"
        :validate="ers.name"
      ></n-input>
    </div>
    <div class="form-wrapper">
      <tag-input :tagIdData="item.maker" :tagNameData="item.makerName"
        api="maker" ref="tagInputm" @nullCheckVal="nullCheckVal" @resetForm="resetForm('makerInput')"
        :validate="ers.maker"
      >
        <input
          v-if="item.maker.length === 0"
          v-model="makerInput"
          type="text"
          class="input"
          :placeholder="lang[2]"
          @input="$refs.tagInputm.getCandidates(makerInput)"
        >
      </tag-input>
    </div>
    <div class="form-wrapper">
      <tag-input :tagIdData="item.category" :tagNameData="item.categoryName"
        api="item_category" ref="tagInputc" @nullCheckVal="nullCheckVal" @resetForm="resetForm('categoryInput')"
        :validate="ers.item_category"
      >
        <input
          v-if="item.category.length === 0"
          v-model="categoryInput"
          type="text"
          class="input"
          :placeholder="lang[3]"
          @input="$refs.tagInputc.getCandidates(categoryInput)"
          @focus="$refs.tagInputc.getItemCategory()"
        >
      </tag-input>
    </div>
    <div class="form-wrapper">
      <tag-input :tagIdData="item.character" :tagNameData="item.characterNames"
        api="character" ref="tagInput" @nullCheckVal="nullCheckVal" @resetForm="resetForm('characterInput')"
        :validate="ers.characterInput"
      >
      <input
        v-model="characterInput"
        type="text"
        class="input"
        :placeholder="item.character.length===0? lang[4] : lang[5]"
        @input="$refs.tagInput.getCandidates(characterInput)"
      >
      </tag-input>
    </div>
    <div class="form-wrapper">
      <n-input
        v-model="item.price"
        type="number"
        :placeholder="lang[6]"
        @chargeRifleInput="nullCheckVal"
        :validate="ers.price"
      ></n-input>
    </div>
    <!-- <div class="form-wrapper">
      <div style="width: 80vw;text-align: left;margin: auto;">
        <input type="checkbox" id="is_fee" name="is_fee" v-model="item.is_fee">
        <label for="is_fee" style="margin-left: 10px;">{{lang[7]}}</label>
      </div>
    </div> -->
    <div class="user-form select-wrapper">
      <n-select @nullCheckVal="nullCheckVal" v-model="item.state" :options="stateObj" :placeholder="lang[8]">
      </n-select>

    </div>
    <div class="form-wrapper">
      <textarea
        v-model="item.message"
        class="textarea"
        placeholder="message"
      ></textarea>
    </div>
    <p class="validate" v-if="ers.message">{{ ers.message }}</p>
    <div class="text-center">
      <btn v-if="isSend" type="primary" size="normal" :label="lang[12]" @click="create()" :loading="loading"></btn>
      <btn v-else type="disabled" size="normal" :label="lang[12]"></btn>
    </div>
    <app-menu active="home"></app-menu>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</template>

<script>

import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import Btn from '../../components/Button.vue'
import axios from 'axios';
import Notice from '../../components/Notice.vue'
import NInput from '../../components/Input.vue'
import NSelect from '../../components/Select.vue'
import TagInput from '../../components/TagInput.vue'
import ItemNewLangMaster from '../../masters/langMaster/ItemNewLangMaster.js'
import errHandling from '../../mixins/apiErrorHandle.js'

export default {
  name: 'RegisterIndex',

  components: {
    AppMenu,
    AppTitle,
    Btn,
    Notice,
    NInput,
    NSelect,
    TagInput,
  },

  mixins: [errHandling],

  data() {
    return {
      lang: ItemNewLangMaster[this.$store.state.account.lang],
      stateObj: [
        {
          label: ItemNewLangMaster[this.$store.state.account.lang][9],
          value: '0',
        },
        {
          label: ItemNewLangMaster[this.$store.state.account.lang][10],
          value: '1',
        },
      ],
      item: {
        saler_id: '',
        name: '',
        character: [],
        characters: '',
        characterNames: [],
        maker: [],
        makerName: [],
        makers: '',
        category: [],
        categoryName: [],
        categories: '',
        price: '',
        is_fee: '',
        delivery_service: 0,
        state: '',
        message: '',
        img1: '',
        img2: '',
        img3: '',
        img4: '',
        img5: '',
        is_draft: '',
      },
      stateArr: {
        '0': 'used',
        '1': 'new'
      },
      uploadFile: null,
      isSend: false,
      isNotice: false,
      loading: false,
      defcamera: 'https://s3.amazonaws.com/nerzex-img-store/20197191123149def-camera.png',
      stateArr: ['used','new'],
      characterInput: '',
      makerInput: '',
      characters: [],
      isAnimeSubmit: false,
      animeName: [],
      animeId: [],
      animeInput: '',
      animeCreate: false,
      categoryInput: '',
      nameValidate: "",
      priceValidate: "",
      img1Validate: "",
      ers: {
        character: "",
        maker: "",
        item_category: "",
        message: "",
      }
    };
  },


  methods: {
    create() {
      this.loading = true
      this.item.is_draft = 1
      this.item.saler_id = this.$store.state.account.id
      if(!this.item.is_fee) {
        this.item.is_fee = false
      }
      //キャラクターの配列作成、メーカーとカテゴリーのidを送信するように成形
      this.item.characterSubmit = JSON.stringify(this.item.character)
      this.item.makerSubmit = `${this.item.maker[0]}`
      this.item.categorieSubmit = `${this.item.category[0]}`

      axios.post('private/item/new', this.item).then((data) => {
        // this.userData = data.data.updatedModel
        this.item.id = data.data.model.id
        this.createPayment()
      }).catch((err) => {
        this.errorHandling(err)
        this.noticeType = 'alert'
        this.noticeTitle = 'Error'
        this.noticeText = err.message
        this.isNotice = true
        setTimeout(this.isNotice = false ,5000)
        this.loading = false
      });
    },

    selectedFile(e) {
      this.defcamera = 'https://s3.amazonaws.com/nerzex-img-store/20197191132833282.gif'
      e.preventDefault()
      this.uploadFile = e.target.files[0]
      const uploadData = new FormData()
      uploadData.append('file', this.uploadFile)
      axios.post('private/aws/s3up', uploadData)
      .then((data) => {
        this.item[e.target.id] = data.data.name
        this.defcamera = 'https://s3.amazonaws.com/nerzex-img-store/20197191123149def-camera.png'
        this.nullCheckVal()
      }).catch((err) => {
        this.defcamera = 'https://s3.amazonaws.com/nerzex-img-store/20197191123149def-camera.png'
        console.log(err)
      });
    },

    nullCheckVal() {
      let checkArr = ['name','character','maker','price','state','img1']
      for(let i=0, len=checkArr.length; i < len; i++) {
        if(!this.item[checkArr[i]] || !this.item['character'].length || !this.item['maker'].length || !this.item['category'].length) {
          this.isSend = false
          return false
        } else {
          this.isSend = true
        }
      }
    },

    resetForm(val) {
      this[val] = ''
    },

    createPayment() {
      const amount = (Number(this.item.price) * 1.036)
      axios.post('/private/stripe/payment', {
        amount: Math.round(amount),
        id: this.item.id,
        price: this.item.price,
        saler_id: this.item.saler_id,
        buyer_id: this.item.buyer_id,
        item_id: this.item.id,
      }).then(data =>　{
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'this item is registered!'
        this.isNotice = true
        this.loading = false
        setTimeout(this.isNotice = false ,5000)
        this.$router.push('/home')
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>

<style scoped>
.user-form {
  margin: 20px;
}

.market-title{
  background: #58acfa
}

.new-item {
  margin-bottom: 90px;
}

.img-area {
  display: flex;
  overflow-x: scroll;
  margin-top: 20px;
}

.item-img-wrapper {
  width: 100px;
  height: 100px;
  margin: 10px;
}

.item-img {
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.sub-preview img {
  width: inherit;
  height: inherit;
}

.form-wrapper {
  margin: 20px;
  display:flex;
  justify-content: center;
}

input[type="text"], input[type="number"] {
  padding: 10px 5px;
  border: none;
  border-radius: 0;
  outline: none;
  background: none;
  border-bottom: 1px solid #868686;
  font-size: 14px;
  width: 100%;
}

.input::placeholder {
  color: #BFBFBF;
  font-size: 14px;
}

.textarea {
  padding: 5px;
  border: 1px solid #707070;
  border-radius: 5px;
  width: 100vw;
  height: 200px;
  background: #fff;
}

@media screen and (min-width: 800px){
  .img-area {
    width: 80vw;
    overflow-x: auto;
    margin: 20px auto;
  }

  .item-img-wrapper {
    width: 150px;
    height: 150px;
  }

  .item-img {
    width: 150px;
    height: 150px;
  }

}
</style>
